exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] .rTPVWGh2KKCAdUJV5wCjK{margin-bottom:16px}html[dir=ltr] .rTPVWGh2KKCAdUJV5wCjK{margin-left:16px}html[dir=rtl] .rTPVWGh2KKCAdUJV5wCjK{margin-right:16px}", ""]);
// Exports
exports.locals = {
	"confirmButton": "rTPVWGh2KKCAdUJV5wCjK"
};